import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Staff access tokens last 60 minutes. Without this, the first action after that hour
// failed with "Not authenticated" even though a 7-day refresh cookie was still valid.
let refreshing = null;

api.interceptors.response.use(undefined, async (error) => {
  const req = error.config;
  const status = error.response?.status;
  const url = req?.url || "";
  const skip = url.includes("/auth/refresh")
    || url.includes("/auth/verify-code") || url.includes("/auth/request-code")
    || url.startsWith("/public/") || url.startsWith("/assess/");
  if (status !== 401 || skip || req?._retried) return Promise.reject(error);

  req._retried = true;
  try {
    refreshing = refreshing || api.post("/auth/refresh").finally(() => {
      refreshing = null;
    });
    await refreshing;
  } catch {
    // No valid refresh cookie: let the caller handle it. AuthContext will show sign-in.
    return Promise.reject(error);
  }
  return api(req);
});

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function fmt(ts) {
  if (!ts) return "—";
  try {
    return new Date(ts).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return ts;
  }
}

export function clock(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  const m = Math.floor(s / 60);
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}:${String(
    s % 60,
  ).padStart(2, "0")}`;
}

export default api;
